import React from 'react'
import { useLocation } from 'react-router-dom'
import { REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN } from '../config/settings/environment'
import WizardLayout from '../components/Layouts/WizardLayout'
import AuthenticationContainer from '../containers/AuthenticationProvider/AuthenticationProvider.container'
import ConfirmNewAffidavitDialogContainer from '../containers/RegisterWizard/ConfirmNewAffidavitDialog.container'
import RegisterWizardWelcomeContainer from '../containers/RegisterWizard/RegisterWizardWelcome.container'
import RegisterWizardPersonalInformationContainer from '../containers/RegisterWizard/RegisterWizardPersonalInformation.container'
import RegisterWizardUniquePassContainer from '../containers/RegisterWizard/RegisterWizardUniquePass.container'
import RegisterWizardBusinessAreasContainer from '../containers/RegisterWizard/RegisterWizardBusinessAreas.container'
import RegisterWizardBusinessInformationContainer from '../containers/RegisterWizard/RegisterWizardBusinessInformation.container'
import RegisterWizardBusinessSearchContainer from '../containers/RegisterWizard/RegisterWizardBusinessSearch.container'
import RegisterWizardCompleteContainer from '../containers/RegisterWizard/RegisterWizardComplete.container'
import RegisterWizardConsiderationsContainer from '../containers/RegisterWizard/RegisterWizardConsiderations.container'
import RegisterWizardEmailVerifyContainer from '../containers/RegisterWizard/RegisterWizardEmailVerify.container'
import RegisterWizardRecoveryCompanyContainer from '../containers/RegisterWizard/RegisterWizardRecoveryCompany.container'
import { BusinessIcon, BusinessCenterIcon, CheckIcon, MailIcon, PersonIcon } from './RegisterWizard.styles'

/**
 * The RegisterWizard's page.
 */
const RegisterWizard = () => {
  const location = useLocation()
  const { state } = location

  return (
    <AuthenticationContainer>
      <ConfirmNewAffidavitDialogContainer />
      <WizardLayout
        defaultStepID={state?.defaultStepID || 'welcome'}
        steps={[
          {
            component: <RegisterWizardWelcomeContainer />,
            id: 'welcome',
            number: 0,
            showNumber: false,
            showStep: false
          },
          {
            component: <RegisterWizardUniquePassContainer />,
            icon: <PersonIcon size="1.5em" />,
            id: 'by-unique-pass',
            name: 'Información personal',
            number: 1,
            showNumber: true,
            showStep: true
          },
          {
            component: <RegisterWizardPersonalInformationContainer />,
            icon: <PersonIcon size="1.5em" />,
            id: 'personal-info',
            name: 'Información personal',
            number: 1,
            showNumber: true,
            showStep: true
          },
          {
            component: <RegisterWizardEmailVerifyContainer />,
            icon: <MailIcon size="1.3em" />,
            id: 'email-verify',
            name: 'Correo',
            number: 2,
            showNumber: true,
            showStep: true
          },
          {
            component: <RegisterWizardBusinessSearchContainer />,
            icon: <BusinessIcon size="1.3em" />,
            id: 'business-search',
            name: 'Asociar empresa',
            number: 3,
            showNumber: true,
            showStep: true
          },
          {
            component: <RegisterWizardBusinessInformationContainer />,
            icon: <BusinessIcon size="1.3em" />,
            id: 'business-info',
            name: 'Asociar empresa',
            number: 3,
            showNumber: true,
            showStep: true
          },
          (REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === true || REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === 'true') && {
            component: <RegisterWizardRecoveryCompanyContainer />,
            icon: <BusinessIcon size="1.3em" />,
            id: 'recovery-company',
            name: 'Asociar empresa',
            number: 3,
            showNumber: true,
            showStep: true
          },
          {
            component: <RegisterWizardBusinessAreasContainer />,
            icon: <BusinessCenterIcon size="1.3em" />,
            id: 'business-areas',
            name: 'Agregar rubros',
            number: 4,
            showNumber: true,
            showStep: true
          },
          {
            component: <RegisterWizardConsiderationsContainer />,
            icon: <CheckIcon size="1.3em" />,
            id: 'considerations',
            name: '¡Listo!',
            number: 5,
            showNumber: false,
            showStep: true
          },
          {
            component: <RegisterWizardCompleteContainer />,
            icon: <CheckIcon size="1.3em" />,
            id: 'complete',
            name: '¡Listo!',
            number: 5,
            showNumber: false,
            showStep: true
          }
        ].filter(Boolean)}
      />
    </AuthenticationContainer>
  )
}

export default RegisterWizard
